import PerfectScrollbar from 'perfect-scrollbar';

$(function() {
	var scrollables = Array.from(document.querySelectorAll('.scrollable'));
	if (scrollables.length > 0) {
		scrollables.forEach( el => new PerfectScrollbar(el) );
	}
});

window.addScrollbar = (element) => new PerfectScrollbar(element);